/** DriverPickerSlot — wraps DriverPicker on the Driver tab.
 *  Extracted verbatim from DriverTab.jsx. Phase 9.3 adds a "Driver TBA"
 *  checkbox above the picker that bypasses required-field validation on
 *  the driver_* fields and blocks gate check-in until cleared. */
import DriverPicker from "@/components/DriverPicker";
import { useSlotLabel } from "../hooks/useSlotLabels";

export default function DriverPickerSlot({ values, set, ctx }) {
  const { booking, prefill } = ctx;
  const tba = !!values.driver_tba;
  const lbl = useSlotLabel("driver.picker");

  const captureLicence = ({ type, number, state }) => {
    if (type   !== undefined) set("driver_licence_type",   type   || "");
    if (number !== undefined) set("driver_licence_number", number || "");
    if (state  !== undefined) set("driver_licence_state",  state  || "");
  };

  const toggleTba = (v) => {
    set("driver_tba", v);
    // Clearing TBA leaves current values alone. Ticking TBA blanks
    // any half-entered driver fields so the record isn't confusing.
    if (v) {
      set("assigned_driver_id", "");
      set("driver_licence_type",   "");
      set("driver_licence_number", "");
      set("driver_licence_state",  "");
    }
  };

  return (
    <div>
      <label
        className={`flex items-center gap-2 mb-3 p-2 rounded border cursor-pointer transition-colors
          ${tba ? "bg-amber-50 border-amber-300" : "bg-slate-50 border-slate-200 hover:bg-slate-100"}`}
        data-testid="driver-tba-toggle-label"
      >
        <input
          type="checkbox"
          checked={tba}
          onChange={(e) => toggleTba(e.target.checked)}
          className="h-4 w-4"
          data-testid="driver-tba-checkbox"
        />
        <span className={`text-sm font-medium ${tba ? "text-amber-800" : "text-slate-700"}`}>
          {lbl("tba_checkbox_label", "Driver TBA — assign later")}
        </span>
        {tba && (
          <span className="ml-auto text-[11px] text-amber-700 italic">
            {lbl("tba_warning_text", "Booking will show as outstanding · gate check-in and admin approval blocked until real driver assigned")}
          </span>
        )}
      </label>

      <div className={tba ? "opacity-50 pointer-events-none select-none" : ""}>
        <DriverPicker
          value={values.assigned_driver_id || ""}
          onChange={(id) => set("assigned_driver_id", id)}
          onCaptureLicence={captureLicence}
          clientId={ctx.clientId || booking?.client_id || prefill?.clientId || null}
          required={!tba}
          bookerId={values.approved_booker_id || null}
          prefillName={prefill?.driver_name || ""}
          prefillPhone={prefill?.driver_phone || ""}
          currentLicence={{
            type:   values.driver_licence_type   || "",
            number: values.driver_licence_number || "",
            state:  values.driver_licence_state  || "",
          }}
        />
      </div>
    </div>
  );
}
